const darkblue = {
  5: '#f2f5f7',
  10: '#e4eaf0',
  25: '#bfcbd9',
  50: '#99adc3',
  70: '#4C7096',
  100: '#003369',
}

const lightblue = {
  5: '#f2f9fc',
  10: '#e3f3fa',
  50: '#ade7ff',
  100: '#0099da',
}

const colors = {
  background: {
    default: darkblue[10],
    contrastBackground: '#FFFFFF',
    activeNavBackground: '#F2F5F7',
    activeNavRectangle: '#08C792',
  },

  white: {
    main: '#FFFFFF',
    focus: '#FFFFFF',
  },

  black: {
    main: '#000000',
    light: '#141414',
    focus: '#000000',
  },

  primary: {
    main: darkblue[100],
    focus: '#001E3D',
    dark: '#001E3D',
    light: darkblue[50],
    lighter: darkblue[25],
    contrastText: '#fff',
  },

  secondary: {
    main: lightblue[100],
    focus: '#0C688F',
    dark: '#0C688F',
    light: lightblue[50],
    lighter: lightblue[10],
    lightest: '#F2FAFD80',
    contrastText: '#fff',
  },

  text: {
    main: '#212529',
    focus: '#63676C',
    disabled: '#DADADA',
  },

  info: {
    main: darkblue[100],
    focus: darkblue[70],
    light: darkblue[50],
    dark: '#1E3955',
  },

  success: {
    main: '#24A148',
    contrastText: '#ffffff',
  },

  warning: {
    main: '#F1C21B',
    light: '#FDDF9B',
  },

  error: {
    main: '#C41B24',
    dark: '#B82F41',
  },

  action: {
    active: darkblue[100],
    hoverOpacity: 0.08,
    selectedOpacity: 0.16,
    focusOpacity: 0.08,
  },

  light: {
    main: '#e9ecef',
    focus: '#e9ecef',
    light: '#F4F5F7',
  },

  dark: {
    main: '#212529',
    focus: '#63676C',
    disabled: '#DADADA',
  },

  grey: {
    100: '#fcfcfc',
    200: '#e2e1e1',
    300: '#c7c5c5',
    400: '#9d9a9a',
    500: '#736f6f',
    600: '#393737',
  },

  darkblue: {
    5: darkblue[5],
    10: darkblue[10],
    25: darkblue[25],
    50: darkblue[50],
    100: darkblue[100],
  },

  lightblue: {
    5: lightblue[5],
    10: lightblue[10],
    50: lightblue[50],
    100: lightblue[100],
  },

  gradients: {
    primary: {
      main: '#12316E',
      state: '#0099da',
    },

    secondary: {
      main: '#0099da',
      state: '#12316E',
    },

    info: {
      main: '#2152ff',
      state: '#21d4fd',
    },

    success: {
      main: '#17ad37',
      state: '#98ec2d',
    },

    warning: {
      main: '#f08c00',
      state: '#fbcf33',
    },

    error: {
      main: '#f03e3e',
      state: '#ff667c',
    },

    light: {
      main: '#ced4da',
      state: '#ebeff4',
    },

    dark: {
      main: '#141727',
      state: '#3a416f',
    },
  },
}

export default colors
